/**
 * 방 옵저빙 / 추가공간 옵저빙 세션 API 요청 타입
 * @see API: POST/PUT /api/v1/visit-counsels/{visitCounselId}/room-observing-sessions/{sessionId}/*
 * @see API: POST/PUT /api/v1/visit-counsels/{visitCounselId}/additional-space-observing-sessions/{sessionId}/*
 */

/** 방 옵저빙 세션 시작 요청 (movingItems, serviceSet 포함) */
export interface StartRoomObservingSessionRequest {
  movingItems: MovingItemRequest[];
}

/** 방 옵저빙 세션 영상 수정 요청 */
export interface RecordRoomObservingVideoRequest {
  videoToken: string;
}

/** 추가공간 옵저빙 세션 시작 요청 */
export interface StartAdditionalSpaceObservingSessionRequest {
  movingItems: AdditionalSpaceMovingItemRequest[];
}

/** 추가공간 옵저빙 세션 영상 수정 요청 */
export interface RecordAdditionalSpaceObservingVideoRequest {
  videoToken: string;
}

/** ServiceSet enum 값 */
export const SERVICE_SET_VALUES = [
  'DISASSEMBLY_TRANSPORT_INSTALLATION',
  'DISASSEMBLY_TRANSPORT',
  'TRANSPORT_ONLY',
  'TRANSPORT_TO_FIRST_FLOOR',
  'DISPOSAL',
] as const;

export type ServiceSet = (typeof SERVICE_SET_VALUES)[number];

export const SERVICE_SET_LABELS: Record<ServiceSet, string> = {
  DISASSEMBLY_TRANSPORT_INSTALLATION: '분해/운반/설치',
  DISASSEMBLY_TRANSPORT: '분해/운반',
  TRANSPORT_ONLY: '운반만',
  TRANSPORT_TO_FIRST_FLOOR: '1층으로 운반',
  DISPOSAL: '버림',
};

/** 이사 물품 응답 (MovingItemView) - sessions.roomObserving[].movingItems */
export interface MovingItemView {
  id: string;
  specId: string;
  attributes?: Record<string, string>;
  serviceSet?: ServiceSet | null;
}

/** 방 옵저빙용 이사 물품 요청 (serviceSet 필수) */
export interface MovingItemRequest {
  specId: string;
  attributes: Record<string, string>;
  serviceSet: ServiceSet;
}

/** 추가공간 옵저빙용 이사 물품 요청 (serviceSet 포함) */
export interface AdditionalSpaceMovingItemRequest {
  specId: string;
  attributes: Record<string, string>;
  serviceSet?: ServiceSet;
}

/** 방 옵저빙 세션 이사 물품 기록 요청 */
export interface RecordRoomObservingMovingItemsRequest {
  movingItems: MovingItemRequest[];
}

/** 추가공간 옵저빙 세션 이사 물품 기록 요청 */
export interface RecordAdditionalSpaceObservingMovingItemsRequest {
  movingItems: AdditionalSpaceMovingItemRequest[];
}

/** Room 짐별 ServiceSet 일괄 기록 요청 (Intake 세션) */
export interface RecordMovingItemServiceSetsRequest {
  serviceSets: Record<string, { movingItemId: string; serviceSet: ServiceSet }[]>;
}
